module.exports = __webpack_public_path__ + "img/7.3202fcfa.png";